import { FC } from "react";
import { t, zoneAr } from "../../i18n/ar";

// ─── Slot code badge ────────────────────────────────────────────────────────
// The single most important thing on a pick card after the quantity: WHERE
// to walk. Giant mono code on a dark background so it reads from 2 metres;
// a red "no location" chip when the product was never slotted.
export const LocationBadge: FC<{ location?: string; zone?: string | null; overflow?: string[]; big?: boolean }> = ({ location, zone, overflow, big }) => {
    if (!location) {
        return (
            <span className={`inline-flex items-center gap-1 rounded-xl bg-red-100 px-3 py-1 font-black text-red-700 ${big ? "text-xl" : "text-base"}`}>
                📍 {t.noLocation}
            </span>
        );
    }
    const zoneLabel = zoneAr(zone);
    return (
        <div className="flex flex-wrap items-center gap-2">
            <span className={`inline-flex items-center gap-2 rounded-2xl bg-slate-900 px-4 py-1.5 font-black text-white shadow ${big ? "text-5xl" : "text-3xl"}`}>
                <span aria-hidden>📍</span>
                <span className={`font-sans ${big ? "text-2xl" : "text-lg"} text-amber-300`}>{t.locationWord}</span>
                <span className="ltr font-mono tracking-widest">{location}</span>
            </span>
            {zoneLabel && <span className="rounded-lg bg-slate-100 px-2 py-0.5 text-base font-bold text-slate-600">{zoneLabel}</span>}
            {overflow && overflow.length > 0 && (
                <span className="ltr rounded-lg bg-amber-100 px-2 py-0.5 font-mono text-lg font-black text-amber-800">+ {overflow.join(" · ")}</span>
            )}
        </div>
    );
};
